import { useMutation, useQuery } from '@tanstack/react-query'

import { showPrompt, shownPrompt } from './functions'

export function useShowPrompt() {
  return useQuery(['showPrompt'], showPrompt, {
    enabled: false,
  })
}

export function useShownPrompt() {
  return useMutation(shownPrompt)
}
